import React, {useEffect, useState} from 'react'
import download from 'downloadjs';
import { Dialog, DialogActions, DialogContent, DialogContentText, IconButton, ListItem, Tooltip} from '@material-ui/core'
import {Checkbox, DialogTitle, List, ListItemText} from "@mui/material";
import {Add, Add as AddIcon, Delete, Edit, AddShoppingCartOutlined, ShoppingCartOutlined} from '@material-ui/icons'
import {
  DataGridPremium,
  GridColDef, GridCsvExportOptions, GridCsvGetRowsToExportParams, gridSortedRowIdsSelector,GridToolbarContainer, GridValueFormatterParams, useGridApiContext,
  useGridApiRef,
  GridRowOrderChangeParams, GRID_CHECKBOX_SELECTION_COL_DEF, gridFilteredSortedRowEntriesSelector,
} from "@mui/x-data-grid-premium";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import styles from './EventPurchaserLinkTable.module.css'
import {EventState, setEvent, useEventState} from "../../slices/eventSlice";
import {useParams} from "react-router";
import {Grid, InputLabel, Stack} from "@mui/material";
import {ButtonProps} from "@mui/material/Button";
import Button from '@mui/material/Button';
import {useQueryClient} from "react-query";
import dayjs from "dayjs";
import axios from "axios";
import {useHistory} from "react-router-dom";
import LoadingBackdrop from "../../components/common/LoadingBackdrop";
import {useAutoEvt} from "../../queries/useAutoEvt";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import DonationPage from "../EventTransferPage/EventDonationPage";


const eventItemsDefaults = {
  id: 0,
  control: 0,
  fieldname: '',
  fieldtype: '',
  displayvalue: '',
  active: true,
  uditem: '',
  items: '',
  itemids: [],
  displayforallguest: false,
}

interface Params {
  eventid: string
}

const EventPurchaserLinkTable = () => {
  const { eventid } = useParams<Params>()
  useAutoEvt(eventid)

  const apiRef = useGridApiRef();
  const queryClient = useQueryClient()
  const eventState = useEventState()
  const [dialogUpload, setDialogUpload] = React.useState({ msg: "", id: 0, open: false, uploadCount: null, uploadDuplicates: null })
  const [dialogObj, setDialogObj] = React.useState({ msg: "", id: 0 })
  const [dialogMsg, setDialogMsg] = React.useState("")
  const [transactionId, setTransactionId] = useState<number>(0)
  const [purchaserData, setPurchaserData] = useState([])
  const [reloadData, setReloadData] = React.useState(1)
  const [isDataLoading, setIsDataLoading] = React.useState(false)
  const [checkboxSelection, setCheckboxSelection] = React.useState([])
  const [value, setValue] = React.useState(0);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  const history = useHistory()

  useEffect(() => {
    const getData = async () => {
      var body = {"eventid": eventid}
      const {data} = await axios.post('/purchaserlink', body)
      const parsedData = JSON.parse(data.jsonString)
      const newPurchaserData = parsedData.purchasers.map((item) => {
        return { id: item.purchaserid, ...item}
      })
      setPurchaserData(newPurchaserData)
    }
    getData()
  }, [eventid, reloadData])

  useEffect(() => {
    console.log(transactionId)
  }, [transactionId])

  const purchaserupload = async () => {
    setIsDataLoading(true)
    const body = {
      'eventid': eventid,
      'idlist': checkboxSelection.filter((item) => item.value == true)?.map(cbSels => {return cbSels.id})
    }
    const response = await axios.post(`purchaserlinkuploadpre`, body)
    const parsedData = JSON.parse(response.data.jsonString)

    setIsDataLoading(false)

    setDialogUpload({ msg: "", id: 0, open: true, uploadCount: parsedData?.uploadcount, uploadDuplicates: parsedData?.duplicates })
  }

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const purchaserautolink = () => {
    // Scott
    setIsDataLoading(true)
    const body = {eventid: eventid}
    axios.post(`purchaserlinkauto`, body).then(response => {
      const parsedData = JSON.parse(response.data.jsonString)
      setDialogOpen(true);
      setDialogMessage(parsedData.message);
      setReloadData(reloadData+1)
      setIsDataLoading(false)
    })
  }

  const downloadExcel = async () => {
    setIsDataLoading(true)
    axios.post('/purchaserlinkreport', {eventid: eventid}, {responseType: "blob"}).then(response => {
      var filename = eventState.eventName + '-Purchasers.xlsx';
      var disposition = response.headers['content-disposition']
      var contentType = response.headers['content-type']
      if (disposition && disposition.indexOf('attachment') !== -1) {
        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, '');
        }
      }
      if (response.data) {
        download(response.data, filename, contentType);
      }
      setIsDataLoading(false)
    })
  }

  const closeDialog = () => {
    setDialogUpload({ msg: "", id: 0, open: false, uploadCount: [], uploadDuplicates: [] })
    setDialogMsg('')
    setDialogObj({
      msg: '',
      id: 0
    })
  }

  const purchaserlinkupload = async () => {
    setIsDataLoading(true)
    const body = {
      'eventid': eventid,
      'idlist': checkboxSelection.filter(item => item.value == true)?.map(cbSels => {return cbSels.id})
    }
    const response = await axios.post(`purchaserlinkupload`, body)
    const parsedData = JSON.parse(response.data.jsonString)
    console.log(parsedData.uploadcount)
    console.log(parsedData.duplicates)
    // uploadcount\":3,\"duplicates\":[]
    // purchaserlinkuploadpre

    setReloadData(reloadData+1)

    setIsDataLoading(false)
    setDialogUpload({ msg: "", id: 0, open: false, uploadCount: [], uploadDuplicates: [] })
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckboxSel(event.target.id, event.target.checked)
  }
  const setCheckboxSel = (id, value) => {
    const selections = checkboxSelection.filter((op) => op.id != id)
    if (id == 0) {
      if (value) {
        const gridFilteredRows = gridFilteredSortedRowEntriesSelector(apiRef)
        var selectedItems = []
        gridFilteredRows.forEach(listofstuff => {
          if (!listofstuff.model.contactid) {
            selectedItems.push({id: listofstuff.id, value: value})
          }
        })
        setCheckboxSelection([{id: 0, value: value}, ...selectedItems])
      }
      else {
        setCheckboxSelection([])
      }
    }
    else {
      const selectionValues = [{id: Number(id), value: value}, ...selections].filter((op) => op.id != 0)
      const allValue = shouldAllBeSelected(selectionValues)

      selectionValues.push({id: 0, value: allValue})
      setCheckboxSelection(selectionValues)
    }
  }

  const shouldAllBeSelected = (selections) => {
    var allSelected = true
    selections.forEach(listofstuff => {
      if (listofstuff.value == false) {
        allSelected = false
      }
    })
    return allSelected
  }

  const getCheckboxSel = (id) => {
    const selection = checkboxSelection.find((op) => op.id === id)
    return selection ? selection.value : false
  }

  var checkboxCol: GridColDef = {
    "field": 'checkedeContactid',
    "headerName":'',
    "type": 'string',
    "headerAlign": 'right',
    "width": 180,
    "align": 'right',
  }
  checkboxCol = GRID_CHECKBOX_SELECTION_COL_DEF
  checkboxCol.field = 'checkedeContactid'
  checkboxCol.headerName = ''
  checkboxCol.width = 120
  checkboxCol.renderHeader = (params) => {
    return (
        <Checkbox
            name={'0'}
            id={'0'}
            checked={getCheckboxSel(0)}
            onChange={handleChange}
            inputProps={{ 'aria-label': 'controlled' }}
            size="medium"
        />
    )
  }
  checkboxCol.renderCell = (params) => {
    if (params.row.contactid) {
      return (
          <div>{params.row.contactid}</div>
      )
    }
    else {
      return (
          <Checkbox
              name={params.row.id}
              id={params.row.id}
              checked={getCheckboxSel(params.row.id)}
              onChange={handleChange}
              inputProps={{'aria-label': 'controlled'}}
              size="medium"
          />
      )
    }
  }

  const columns: GridColDef[] = [
    {
      field: 'button',
      headerName: 'Link',
      width: 130,
      disableExport: true,
      sortable: false,
      renderCell: (params) => {
        if(params.row.contactid > 0) {
          if (params.row.transactionlinklocked) {
            return <></>
          }
          else {
            return <Button
                variant="contained"
                color="secondary"
                onClick={() => {
                  const body = {eventid: eventid, purchaserid: params.row.purchaserid}
                  axios.put(`purchaserunlink`, body).then(response => {
                    setReloadData(reloadData+1)
                  })
                }}>
              UnLink
            </Button>;
          }
        }
        return  <Button
            variant="contained"
            color="primary"
            onClick={() => {
              history.replace({
                pathname: '/event/' + eventid + '/eventpurchaserlinking',
                state:{
                  data: params.row,
                }}
              )
            }}>
          Link
        </Button>;

      }
    },
    checkboxCol,
    {
      field: 'first',
      headerName: 'First',
      type: 'string',
      width: 180,
      // valueFormatter: (params: GridValueFormatterParams) => {
      //   return dayjs(params.value as string).format('MM/DD/YYYY hh:mm A')
      // },
    },
    {
      field: 'last',
      type: 'string',
      headerName: 'Last',
      width: 180
    },
    {
      field: 'email',
      type: 'string',
      headerName: 'Email',
      minWidth: 250
    },
    {
      field: 'date',
      headerName: 'Date',
      width: 180,
      valueFormatter: (params: GridValueFormatterParams) => {
        return dayjs(params.value as string).format('MM/DD/YYYY hh:mm A')
      },
    },
    {
      field: 'totalamount',
      type: 'string',
      headerName: 'Total Amount',
      width: 120,
      align: "right",
      valueFormatter: (params: GridValueFormatterParams) => {
        return '$' + params?.value?.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      },
    },
    {
      field: 'transactiontype',
      type: 'string',
      headerName: 'Transaction Type',
      minWidth: 200
    },
    {
      field: 'address',
      type: 'string',
      headerName: 'Address',
      minWidth: 400,
      valueGetter: (gridParams) => {
          const addressValue = gridParams.row?.address + ' ' + gridParams.row?.city + ', ' + gridParams.row?.state + ' ' + gridParams.row?.zip
          return addressValue
      }
      // valueFormatter: (params: GridValueFormatterParams) => {
      //   console.log(params)
      //   return params.value
      // },
    },
  ]
  const getUnfilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
      gridSortedRowIdsSelector(apiRef);

  function CustomGridToolbar() {
    const apiRef = useGridApiContext();

    const handleExport = (options: GridCsvExportOptions) => {
      options.allColumns = true;
      apiRef.current.exportDataAsCsv(options);
    }

    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };

    return (
        <>
          <GridToolbarContainer >
            <>
              <Grid
                  container
                  direction="row"
                  justifyContent="flex-begin"
                  alignItems="center"
                  // border={2}
                  xs={3} sm={4} md={4}
              >
                <Grid item xs={12}>
                  <InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-begin', marginTop: '5px', marginBottom: '5px'}} >
                    <Button
                        variant="contained"
                        size="small"
                        onClick={() => {purchaserautolink()}}
                        color="primary">
                      AUTOLINK
                    </Button>
                  </InputLabel>
                </Grid>
              </Grid>
              <Grid
                  container
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  xs={2} sm={6} md={8}
              >
                <Button
                    {...buttonBaseProps}
                    onClick={() => handleExport({getRowsToExport: getUnfilteredRows})}
                >
                  EXPORT
                </Button>
                {/*<GridToolbarExport style={{color: '#00b2ff'}}/>*/}
              </Grid>
            </>
          </GridToolbarContainer>
        </>
    )
  }

  return (
      <div className={styles.root}>
        <h1>Event Purchaser Link / Transfer</h1>
      <div>
        <Dialog
            open={dialogOpen}
            onClose={() => setDialogOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Auto Link Status"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {dialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDialogOpen(false)} color="primary" autoFocus>
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
            open={dialogUpload.open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
          <DialogTitle>Upload Purchasers to DonorSnap</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              You are about to upload {dialogUpload?.uploadCount} purchasers into your DonorSnap account. Are you sure you want to continue?
            </DialogContentText>
            {dialogUpload?.uploadDuplicates?.length > 0 &&
                <><DialogContentText id="alert-dialog-description">
                  <b>NOTICE:</b> You selected multiple purchaser records with the same email address. This will create a
                  new contact for each one, potentially duplicate contacts.
                </DialogContentText><List sx={{width: '100%', maxWidth: 360, bgcolor: 'background.paper'}}>
                  {dialogUpload?.uploadDuplicates?.map((value) => (
                      <ListItem
                          key={value?.email}
                          disableGutters
                      >
                        <ListItemText primary={value?.email} />
                      </ListItem>
                  ))}
                </List></>
            }
          </DialogContent>
          <DialogActions>
            <Button variant="contained"
                    color="primary"
                    onClick={closeDialog}>CANCEL
            </Button>
            <Button variant="contained"
                    color="primary"
                    disabled={isDataLoading}
                    onClick={purchaserlinkupload}>UPLOAD TO DonorSnap</Button>
          </DialogActions>
        </Dialog>
      </div>

      <LoadingBackdrop open={isDataLoading} />

        <div>
          <Tabs style={{marginBottom: 10}} value={value} onChange={handleTabChange} aria-label="basic tabs example">
            <Tab label="Contact" {...a11yProps(0)} />
            <Tab label="Donation" {...a11yProps(1)} />
          </Tabs>
      {value === 0 && (
          <>
            <DataGridPremium
              autoHeight
              rows={purchaserData}
              columns={columns}
              apiRef={apiRef}
              components={{
                Toolbar: CustomGridToolbar,
                // Footer: CustomGridToolbar,
              }}
              componentsProps={{ toolbar: { csvOptions: { allColumns: true }}}}
            />

            <Stack direction="row" spacing={2}>
              <Button
                  style={{width: '100%'}}
                  variant="contained"
                  size="small"
                  onClick={() => {purchaserupload()}}
                  disabled={isDataLoading || checkboxSelection.length === 0 || !checkboxSelection.find(item => item.value == true)}
                  color="primary">
                UPLOAD SELECTED PURCHASERS TO DONORSNAP
              </Button>
              <Button
                  style={{width: '100%'}}
                  variant="contained"
                  size="small"
                  onClick={() => {downloadExcel()}}
                  color="primary">
                EXPORT ALL TO EXCEL
              </Button>
            </Stack>
          </>
        )}
        {value === 1 && (
            <>
              <DonationPage eventid={eventid} ></DonationPage>
            </>
        )}
        </div>
    </div>
  )
}

export default EventPurchaserLinkTable
